export interface GoogleMapProps extends GoogleMapBase {
  defaultLocation?: PlaceDetails | undefined;
}

export interface GoogleMapBase {
  googleMapAPIKey: string;
  onLocationChange?: (place: PlaceDetails | undefined) => void;
}

//America
export const DEFAULT_LATITUDE = 40.7461796;
export const DEFAULT_LONGITUDE = -74.0120506;
export const DEFAULT_LOCATION_ADDRESS = 'Manhattan, NY 10036, United States';

export interface GoogleMapReduxState {
  place?: PlaceDetails;
}

export interface PlaceDetails {
  idAddress?: string; // An existing id in the db
  name?: string;
  address?: string;
  addressDirections?: string;
  longitude: number;
  latitude: number;
  viewport?: google.maps.LatLngBounds;
  placeID?: string; // A Google map ID of a place
  province?: string;
  city?: string;
  country?: string;
  postalCode?: string;
  googleMapUrl?: string;
}

export const USER_LOCATION_TIMEOUT_MS = 150000;
